import React from 'react';
import classes from './AccessEventOriginLabel.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accessEventHelpers } from '@/utils/helpers';
import endsWith from 'lodash/endsWith';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import t from '@/utils/Language/Referral-translations';
import { displayName } from '@/utils/utils';
import useAccount from '@/hooks/useAccount';

const AccessEventOriginLabel = ({ accessEventOrigin, accessEvent, includeReferralNote = true, ...props }) => {
  const { account } = useAccount();

  const formattedDate = (date) => {
    return moment(date).format('MMM D, YYYY');
  };

  const isReferral = (originType) => {
    return endsWith(originType, 'Referral');
  };

  const includeOrganization = (supporter) => {
    return supporter?.organization_name && supporter?.organization_name != '';
  };

  // Referral notes are stored in `referral_note` on the AccessEventOrigin. They are added when the referral (AccessEvent) is created and displayed to both Pros and Community Members viewing the Referral.
  const hasReferralNote = (accessEventOrigin) => {
    return accessEventOrigin.referral_note !== null && accessEventOrigin.referral_note !== '';
  };

  // Update notes are stored in a json blob in `meta_data` on the AccessEvent - they are displayed to Pros viewing the Referral, but not to Community Members.
  const hasUpdateNote = (accessEvent) => {
    if (!account.data?.is_professional) {
      return false;
    }
    return accessEvent?.meta_data?.update_history !== null && !isEmpty(last(accessEvent?.meta_data?.update_history)?.notes);
  };

  return (
    <>
      <div className={classes.accessEventOriginLabel}>
        {isReferral(accessEventOrigin.origin_type) && props.view != 'ReferralResource' && (
          <>
            <FontAwesomeIcon icon={['fas', 'share']} className="mt-1" />
            <p>
              <span
                dangerouslySetInnerHTML={{
                  __html: t('Referral from supporter', {
                    supporter: accessEventHelpers.supporterName({ accessEventOrigin }),
                    createdAt: formattedDate(accessEventOrigin.created_at)
                  })
                }}
              ></span>
              {includeOrganization(accessEventOrigin.supporter) && (
                <>
                  <br />
                  <em>{accessEventOrigin.supporter.organization_name}</em>
                </>
              )}
            </p>
          </>
        )}
        {accessEventOrigin.origin_type === 'ReferralUpdate' && (
          <>
            <FontAwesomeIcon icon={['fas', 'exchange']} className="mt-1" />
            <p>
              <span>
                {t('Updated date by', {
                  supporter: accessEventHelpers.supporterName({ accessEventOrigin }),
                  updatedAt: formattedDate(accessEventOrigin.updated_at)
                })}
                {includeOrganization(accessEventOrigin.supporter) ? ' (' + accessEventOrigin.supporter.organization_name + ')' : null}
              </span>
            </p>
          </>
        )}
        {accessEventOrigin.origin_type === 'Assessment' && (
          <>
            <FontAwesomeIcon icon={['fas', 'share']} />
            <p>{t('Referral from assessment', { assessmentTitle: accessEventOrigin.assessment.title })}</p>
          </>
        )}
      </div>
      {includeReferralNote && hasReferralNote(accessEventOrigin) && (
        <div className={classes.note}>
          <FontAwesomeIcon size="xs" icon={['fas', 'quote-left']} className="mt-1 me-2" />
          {accessEventHelpers.supporterId({ accessEventOrigin }) == account.data?.id && <span>{t('You said')}</span>}
          {!(accessEventHelpers.supporterId({ accessEventOrigin }) == account.data?.id) && (
            <span>{t('Supporter said', { supporter: accessEventHelpers.supporterName({ accessEventOrigin }) })} </span>
          )}
          <span>&ldquo;{accessEventOrigin.referral_note}&rdquo;</span>
        </div>
      )}
      {includeReferralNote && hasUpdateNote(accessEvent) && (
        <div className={classes.note}>
          <FontAwesomeIcon size="xs" icon={['fas', 'quote-left']} className="mt-1 me-2" />
          {accessEvent.last_updated_by.id == account.data?.id && <span>{t('You said')}</span>}
          {!(accessEvent.last_updated_by.id == account.data?.id) && (
            <span>{t('Supporter said', { supporter: displayName(accessEvent.last_updated_by) })} </span>
          )}
          <span>&ldquo;{last(accessEvent.meta_data?.update_history).notes}&rdquo;</span>
        </div>
      )}
    </>
  );
};

export default AccessEventOriginLabel;
